import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { RootState } from "../../../../../models";
import { API_URL_RETAILER_FWA_COVERAGE } from "../../api";
import { retailerFetch } from "../../retailerFetch";
import * as AT from "../actionTypes";

export const checkFwaCoverage =
    (addressId: string): ThunkAction<void, RootState, unknown, AnyAction> =>
    (dispatch) => {
        const request = retailerFetch(API_URL_RETAILER_FWA_COVERAGE(addressId))
            .then((res) => {
                if (!res.ok) throw new Error(`Dekningssjekk feilet (${res.status})`);
                return res.json();
            })
            .then((json) => {
                if (json.error) throw new Error(json.error);
                return {
                    hasFwa: json.hasFwa as boolean,
                    packages: json.packages ?? [],
                    validAddressId: json.validAddressId as number | undefined,
                };
            });

        dispatch({
            type: AT.RETAILER_FWA_CHECK_COVERAGE,
            payload: request,
        });
    };

export const setFwaSelectedPackage = (packageId: number | null) => ({
    type: AT.RETAILER_FWA_SET_SELECTED_PACKAGE,
    payload: packageId,
});

export const setTraadlosTabActive = (active: boolean) => ({
    type: AT.RETAILER_FWA_SET_TRADLOS_TAB_ACTIVE,
    payload: active,
});
